import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import Navbar from "../components/Navbar";
import { useLanguage } from "../i18n/LanguageContext";
import { useAuth } from "../context/AuthContext";
import { RolePicker } from "./Register";
import api from "../lib/api";

export default function ChooseRole() {
  const { t, lang } = useLanguage();
  const { user, setUser } = useAuth();
  const navigate = useNavigate();
  const [role, setRole] = useState("candidate");
  const [loading, setLoading] = useState(false);

  const handleContinue = async () => {
    setLoading(true);
    try {
      const { data } = await api.post("/auth/set-role", { role, lang });
      setUser(data);
      navigate(role === "candidate" ? "/candidate" : "/company");
    } finally {
      setLoading(false);
    }
  };

  if (user?.role) {
    navigate(user.role === "candidate" ? "/candidate" : "/company", { replace: true });
    return null;
  }

  return (
    <div className="min-h-screen bg-slate-50" data-testid="choose-role-page">
      <Navbar />
      <div className="mx-auto flex max-w-md flex-col px-4 py-16">
        <div className="rounded-md border-2 border-slate-900 bg-white p-8 shadow-[8px_8px_0px_0px_rgba(56,189,248,1)]">
          <h1 className="font-heading text-2xl font-bold tracking-tight text-slate-900">{t("auth.chooseRoleTitle")}</h1>
          <p className="mt-1 text-sm text-slate-500">{t("auth.chooseRoleSubtitle")}</p>
          <div className="mt-6">
            <RolePicker role={role} setRole={setRole} testidPrefix="choose-role" />
          </div>
          <button
            onClick={handleContinue} disabled={loading}
            data-testid="choose-role-continue-button"
            className="mt-6 flex w-full items-center justify-center gap-2 rounded-full border-2 border-slate-900 bg-sky-400 py-2.5 font-heading text-sm font-bold text-slate-900 transition-transform duration-200 hover:-translate-y-0.5 hover:bg-sky-500 hover:shadow-[4px_4px_0px_0px_rgba(15,23,42,1)] disabled:opacity-60"
          >
            {loading && <Loader2 className="h-4 w-4 animate-spin" />} {t("auth.continue")}
          </button>
        </div>
      </div>
    </div>
  );
}
